export default "__VITE_ASSET__DaliktoM__"